import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'

import { WorkflowControlsComponent } from './components/workflowControls.component'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    LocaleModule.forChild(),
  ],
  declarations: [
    WorkflowControlsComponent,
  ],
  exports: [
    WorkflowControlsComponent,
  ],
})
export class MediaWorkflowModule { }
